import styled, { keyframes } from 'styled-components'

import { palette } from '../../theme/palette'

interface CenteredLoaderContainerProps {
  size?: number
}

interface LoaderProps {
  color?: string
  borderTopColor? : string
}

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

export const CenteredLoaderContainer = styled.div<CenteredLoaderContainerProps>`
  position: absolute;
  left: calc(50% - ${props => props.size / 2}px);
  top: calc(50% - ${props => props.size / 2}px);
`

export const Loader = styled.div<LoaderProps>`
  border: 5px solid ${props => props.color || palette.white};
  border-top-color: ${props => props.borderTopColor || '#f3f3f3'};
  border-radius: 50%;
  box-sizing: border-box;
  opacity: 0;
  width: 48px;
  height: 48px;
  animation-name: spin, ${fadeIn};
  animation-duration: 2s, .4s;
  animation-timing-function: linear, ease;
  animation-iteration-count: infinite, 1;
  animation-delay: 0s, .4s;
  animation-fill-mode: forwards;
`
